import ModelBase, {IModelBase} from '@/models/ModelBase'
import TopicComment, { ITopicComment } from '@/models/TopicComment'
import {Attachment} from '@/models/Attachment'
import { KeyPair } from '@/types/KeyPair'

export interface ITopic extends IModelBase {
  user_id?: number
  title?: string
  description?: string
  status?: string
  status_text?: string
  created_user?: string
  updated_user?: string
  topic_comments?: Array<ITopicComment>
}

export default class Topic extends ModelBase {
  user_id?: number
  title? = ''
  description? = ''
  status = ''
  status_text = ''
  created_user = ''
  updated_user = ''
  topic_comments?: Array<TopicComment> = []

  constructor(defaults?: ITopic) {
    super(defaults)
    if (defaults) {
      this.user_id = defaults.user_id
      this.title = defaults.title
      this.description = defaults.description
      this.status = defaults.status
      this.status_text = defaults.status_text
      this.created_user = defaults.created_user
      this.updated_user = defaults.updated_user
      this.topic_comments = defaults.topic_comments?.map(topic_comment => new TopicComment(topic_comment))
    }
  }

  get statusColor(): string {
    switch (this.status) {
      case 'waiting': return '#DF867B'
      case 'in_progress': return '#5487C0'
      case 'done': return '#74B3A6'
      case 'completed': return '#B3BD53'
    }
  }

  get attachments(): Array<Attachment> {
    return this.topic_comments.map(tc => tc.attachments).reduce((a1, a2) => a1.concat(a2), [])
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      description: this.description,
      status: this.status,
      created_user: this.created_user,
      updated_user: this.updated_user
    }
  }
}
